import type { StateCreator } from 'zustand';
import { leadGenApi, type OffenerAnruf } from '../services/leadGenApi';

// ADR 0373 (Riegel C): der offene eigene Anruf von heute. Der Server entscheidet (409 beim Wählen), dieser Zustand
// ist nur die Anzeige („Erst Ergebnis zu …“, Wähl-Knöpfe grau) und lässt den Wählweg früh abbrechen, bevor das Mikro
// gefragt wird. `nachtrag`: das nächste Cockpit trägt das Ergebnis dieses Anrufs nach und öffnet gleich im Abschluss.
export interface OffenerAnrufSlice {
  offenerAnruf: OffenerAnruf | null;
  nachtrag: boolean;
  setzeOffenenAnruf: (o: OffenerAnruf | null) => void;
  ladeOffenenAnruf: () => Promise<void>;
  setzeNachtrag: (v: boolean) => void;
}

export const createOffenerAnrufSlice: StateCreator<OffenerAnrufSlice> = (set) => ({
  offenerAnruf: null,
  nachtrag: false,
  setzeOffenenAnruf: (o) => set({ offenerAnruf: o }),
  ladeOffenenAnruf: async () => {
    try {
      const r = await leadGenApi.offenerAnruf();
      set({ offenerAnruf: r.offen });
    } catch { /* offline oder ohne Recht: dann sperrt die Anzeige nichts, der Server prüft ohnehin */ }
  },
  setzeNachtrag: (v) => set({ nachtrag: v }),
});

/** Darf von dieser Firma und Person aus gewählt werden, obwohl ein Anruf offen ist? (dieselbe Person) */
export function darfWaehlenTrotzOffen(offen: OffenerAnruf | null, leadId: number, personKey?: string | null): boolean {
  if (!offen) return true;
  return offen.lead_id === leadId && (!personKey || personKey === offen.person_key);
}

export function offenerAnrufText(o: OffenerAnruf): string {
  return `Erst Ergebnis zu ${o.person_name ?? 'dem letzten Anruf'}${o.firma ? ` (${o.firma})` : ''}`;
}
